export default __webpack_public_path__ + "static/media/evcharger3.cf552c1d.jpg";